/* ===========================================================================
   EL BENDECIDO — progressively enhanced procedural 3D suds

   Native WebGL, no dependency and no customer-facing controls. The existing
   CSS/SVG suds remain the complete fallback and protect first paint. WebGL is
   considered only after window.load plus an idle window; it is skipped under
   Save-Data, reduced motion, low-power mobile heuristics, or context failure.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__elbProceduralSuds3dReady) return;
  window.__elbProceduralSuds3dReady = true;

  var roots = document.querySelectorAll('[data-elb-suds-3d]');
  if (!roots.length) return;

  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lowPowerMobile = window.innerWidth < 750 && (
    (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 4) ||
    (typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 4)
  );

  if ((connection && connection.saveData) || reducedMotion || lowPowerMobile) return;

  function compile(gl, type, source) {
    var shader = gl.createShader(type);
    if (!shader) return null;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function makeProgram(gl) {
    var vertex = compile(gl, gl.VERTEX_SHADER, [
      'attribute vec4 a_bubble;',
      'uniform float u_time;',
      'uniform float u_dpr;',
      'void main() {',
      '  float phase = a_bubble.x * 5.7 + a_bubble.z * 8.3;',
      '  vec2 drift = vec2(sin(u_time * .21 + phase) * .025, cos(u_time * .16 + phase) * .035);',
      '  gl_Position = vec4(a_bubble.xy + drift, 0.0, 1.0);',
      '  gl_PointSize = a_bubble.w * u_dpr * (.78 + a_bubble.z * .38);',
      '}'
    ].join('\n'));
    var fragment = compile(gl, gl.FRAGMENT_SHADER, [
      'precision mediump float;',
      'void main() {',
      '  vec2 point = gl_PointCoord * 2.0 - 1.0;',
      '  float radius = length(point);',
      '  if (radius > 1.0) discard;',
      '  float rim = smoothstep(1.0, .77, radius) - smoothstep(.77, .60, radius);',
      '  float body = (1.0 - smoothstep(.15, .92, radius)) * .10;',
      '  float glint = (1.0 - smoothstep(.03, .30, distance(point, vec2(-.34, -.38)))) * .62;',
      '  float alpha = rim * .42 + body + glint;',
      '  vec3 color = mix(vec3(.25, .82, .89), vec3(.94, .99, 1.0), glint + rim * .45);',
      '  gl_FragColor = vec4(color, alpha);',
      '}'
    ].join('\n'));

    if (!vertex || !fragment) return null;
    var program = gl.createProgram();
    if (!program) return null;
    gl.attachShader(program, vertex);
    gl.attachShader(program, fragment);
    gl.linkProgram(program);
    gl.deleteShader(vertex);
    gl.deleteShader(fragment);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      gl.deleteProgram(program);
      return null;
    }
    return program;
  }

  function seededBubbles(count) {
    var seed = 726309;
    function random() {
      seed = (seed * 16807) % 2147483647;
      return (seed - 1) / 2147483646;
    }
    var values = new Float32Array(count * 4);
    for (var index = 0; index < count; index += 1) {
      var offset = index * 4;
      var side = random() > .48 ? 1 : -1;
      values[offset] = side * (.48 + random() * .50);
      values[offset + 1] = -.88 + random() * 1.76;
      values[offset + 2] = .25 + random() * .75;
      values[offset + 3] = 14 + random() * 34;
    }
    return values;
  }

  function initialise(root) {
    var canvas = root.querySelector('[data-elb-suds-3d-canvas]');
    if (!canvas) return;

    var gl;
    try {
      gl = canvas.getContext('webgl', {
        alpha: true,
        antialias: false,
        depth: false,
        stencil: false,
        powerPreference: 'low-power',
        premultipliedAlpha: true
      });
    } catch (error) {
      return;
    }
    if (!gl) return;

    var program = makeProgram(gl);
    if (!program) return;
    var position = gl.getAttribLocation(program, 'a_bubble');
    var time = gl.getUniformLocation(program, 'u_time');
    var dprUniform = gl.getUniformLocation(program, 'u_dpr');
    if (position < 0 || !time || !dprUniform) return;

    var count = window.innerWidth < 750 ? 22 : 38;
    var buffer = gl.createBuffer();
    if (!buffer) return;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, seededBubbles(count), gl.STATIC_DRAW);
    gl.useProgram(program);
    gl.enableVertexAttribArray(position);
    gl.vertexAttribPointer(position, 4, gl.FLOAT, false, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);

    var visible = false;
    var frame = 0;
    var lastDraw = 0;
    var stopped = false;
    var dpr = 1;

    function resize() {
      var rect = root.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 750 ? 1.15 : 1.5);
      var width = Math.max(1, Math.round(rect.width * dpr));
      var height = Math.max(1, Math.round(rect.height * dpr));
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
        gl.viewport(0, 0, width, height);
      }
    }

    function draw(now) {
      resize();
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(program);
      gl.uniform1f(time, now * .001);
      gl.uniform1f(dprUniform, dpr);
      gl.drawArrays(gl.POINTS, 0, count);
      if (canvas.hidden) canvas.hidden = false;
    }

    function tick(now) {
      frame = 0;
      if (stopped || !visible || document.hidden) return;
      if (now - lastDraw >= 32) {
        draw(now);
        lastDraw = now;
      }
      frame = window.requestAnimationFrame(tick);
    }

    function resume() {
      if (!stopped && visible && !document.hidden && !frame) {
        frame = window.requestAnimationFrame(tick);
      }
    }

    function pause() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    }

    function stop() {
      stopped = true;
      pause();
      gl.deleteBuffer(buffer);
      gl.deleteProgram(program);
    }

    var observer = typeof window.IntersectionObserver === 'function'
      ? new IntersectionObserver(function (entries) {
          visible = !!(entries[0] && entries[0].isIntersecting);
          if (visible) resume(); else pause();
        }, { rootMargin: '120px 0px', threshold: .01 })
      : null;

    if (observer) observer.observe(root);
    else {
      visible = true;
      resume();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else resume();
    });
    canvas.addEventListener('webglcontextlost', function (event) {
      event.preventDefault();
      canvas.hidden = true;
      if (observer) observer.disconnect();
      stop();
    }, { once: true });
    window.addEventListener('pagehide', function () {
      if (observer) observer.disconnect();
      stop();
    }, { once: true });
  }

  function start() {
    for (var index = 0; index < roots.length; index += 1) initialise(roots[index]);
  }

  function schedule() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 1800 });
    } else {
      window.setTimeout(start, 900);
    }
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
